class tableCustom extends HTMLElement {
    constructor() {
        super();
        this.tabs = this.querySelectorAll('.js-tab');
        this.tabContents = this.querySelectorAll('.js-tab-content');
        
        this.init();
    }
  
    init() {
        this.tabs.forEach(tab => {
            tab.addEventListener('click', this.handleClick.bind(this));
        });
    }

    handleClick(e) {
        const tab = e.target;
        const tabId = tab.dataset.id;
        const tabContent = this.querySelector(`.js-tab-content[data-id="${tabId}"]`);
        
        this.querySelector('.table-custom__content').style.opacity = 0;

        setTimeout(() => {  
            this.tabs.forEach(tab => tab.classList.remove('active'));
            this.tabContents.forEach(tabContent => {
                tabContent.style.maxHeight = 0;
                tabContent.classList.remove('active');
            });
        }, 100);
        
        setTimeout(() => {  
            tab.classList.add('active');
            tabContent.classList.add('active');
        }, 150);

        setTimeout(() => {
            this.querySelector('.table-custom__content').style.transition = 'opacity 0.5s ease-in-out';
            this.querySelector('.table-custom__content').style.opacity = 1;
        }, 1000);
        
    }
}
  
customElements.define('table-custom', tableCustom);